<div class="container">
    <div class="row" style="background-color: gainsboro;">
        <div class="col-10">
            <h3 class="titulo">¿Cómo funciona?</h3>
        </div>
        <div class="col-2">
            <button nbButton size="tiny" class="btn-close float-right" (click)="close()">
                <nb-icon nbPrefix icon="close-outline"></nb-icon>
              </button>
        </div>
    </div>
    <h4 class="altaybaja">Procedimiento para Buscar:</h4>
        <hr>
        <p><span>1 - </span>Seleccionar un Operador </p>
        <p><span>2 - </span>Establecer un rango de Fecha </p> 
        <p><span>3 - </span>Buscar </p>
        <p><span>4 - </span>Si desea exportar simplemente clickee sobre el botón <span>Exportar</span></p>
        <h4 class="altaybaja">Procedimiento para asignar Seguros:</h4>
        <hr>
        <p><span>1 - </span>Tildar sobre la columna <span>Ok Seguro</span> del elemento</p>
        <p><span>2 - </span>Una vez tildada la opción deseada, clickear en el botón <span>Guardar</span> y confirmar</p> 
        <p><span>3 - </span>Esperar que termine de cargar y clickear en el botón <span>Actualizar</span> y confirmar</p>
</div>